import type { IconProps } from "@-/com.npmjs.react-native-nano-icons";
import { withUniwind } from "@-/com.npmjs.uniwind";
import { Platform } from "@-/com.npmjs.react-native";
import { NanoIcon } from "#nano-icon";

const StyledNanoIcon = Platform.OS === "web" ? NanoIcon : withUniwind(NanoIcon);

/** 火 inside the streak flame; inactive days use the authored gray palette. */
export function HanStreakFlame({
  size = 64,
  variant = "active",
  ...props
}: Omit<IconProps<string>, "name"> & { variant?: "active" | "inactive" }) {
  return (
    <StyledNanoIcon
      {...props}
      accessibilityLabel={props.accessibilityLabel ?? ""}
      accessible={props.accessible ?? props.accessibilityLabel !== undefined}
      allowFontScaling={props.allowFontScaling ?? false}
      name={variant === "active" ? "han-streak-flame" : "han-streak-flame-inactive"}
      size={size}
    />
  );
}
